import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import styled from "styled-components";
import "./App.css";

import BasicBackground from "./components/Backgrounds/BasicBackgound";
import theme from "./styles/theme";
import Header from "./components/Header/Header";
import WhiteHeader from "./components/Header/HeaderTop";
import MobileHeader from "./components/Header/MobileHeader";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import Footer from "./components/Footer/Footer";
import { HomePageWrap } from "./pages/Home";
import VideoPage from "./pages/Videos";
import DriversPage from "./pages/Drivers/Drivers";
import HallOfFamePage from "./pages/HallOfFame";
import ResultsPage from "./pages/Results";
import AboutUsPage from "./pages/AboutUs/AboutUs";
import NewsPage from "./pages/News/News";
import NewsPostPage from "./pages/News/Post";
import FaqPage from "./pages/Faq";
import SeasonHighlights from "./pages/Videos/SeasonHighlights";
import ConversationsPage from "./pages/Videos/Conversations";
import StreamsPage from "./pages/Videos/Streams";
import DriverProfile from "./pages/Drivers/PersonalDriverProfile";
import DiscordCallback from "./pages/Auth/DiscordCallback";
import SettingsPage from "./pages/Settings/Settings";
import RegistrationPage from "./pages/Registration";
import NotFound from "./pages/NotFound";
import NoIndexSEO from "./components/SEO/NoIndexSEO";

import CssBaseline from "@mui/material/CssBaseline";

import { HighlightsProvider } from "./contexts/highlights";
import { RacesProvider } from "./contexts/races";
import { StandingsProvider } from "./contexts/standings";
import { BannerProvider } from "./contexts/banner";
import { NewsProvider } from "./contexts/news";
import { DriversProvider } from "./contexts/drivers";
import { ScheduleProvider } from "./contexts/schedule";
import { DriverProvider } from "./contexts/driver";
import { UserProvider } from "./contexts/user";
import { InventoryProvider } from "./contexts/inventory";

import moment from "moment";
import "moment/locale/uk";

moment.locale("uk");

const GlobalContainer = styled.div`
  position: relative;
  width: 100%;
  padding-top: 0px;
  padding-bottom: 24px;
  padding-left: 12px;
  padding-right: 12px;
  margin-right: auto;
  margin-left: auto;
  min-height: calc(100vh - 38px);
  max-width: 1320px;

  @media (max-width: ${theme.breakpointsCustom.mobile}px) {
    padding-top: 60px;
  }
`;

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <UserProvider>
        <InventoryProvider>
          <NewsProvider>
            <BannerProvider>
              <DriversProvider>
                <DriverProvider>
                  <StandingsProvider>
                    <ScheduleProvider>
                      <HighlightsProvider>
                        <RacesProvider>
                          <ThemeProvider theme={theme}>
                            <CssBaseline />
                            <WhiteHeader />
                            <Header />
                            <MobileHeader />
                            <BasicBackground height={800} />
                            <GlobalContainer>
                              <Routes>
                                <Route path="/" element={<HomePageWrap />} />
                                <Route path="/news" element={<NewsPage />} />
                                <Route path="/news/:id" element={<NewsPostPage />} />
                                <Route path="/videos" element={<VideoPage />} />
                                <Route path="/results" element={<ResultsPage />} />
                                <Route path="/drivers" element={<DriversPage />} />
                                <Route path="/hall-of-fame" element={<HallOfFamePage />} />
                                <Route path="/about-us" element={<AboutUsPage />} />
                                <Route path="/faq" element={<FaqPage />} />

                                <Route
                                  path="/videos/conversations"
                                  element={<ConversationsPage />}
                                />

                                <Route path="/videos/streams" element={<StreamsPage />} />

                                <Route path="/videos/seasons/:id" element={<SeasonHighlights />} />

                                {/* Support both URL formats for driver profiles */}
                                <Route path="/drivers/:id" element={<DriverProfile />} />
                                <Route path="/drivers/:id/:seoUrl" element={<DriverProfile />} />

                                {/* Discord OAuth callback */}
                                <Route
                                  path="/auth/discord/callback"
                                  element={
                                    <>
                                      <NoIndexSEO title="Вхід через Discord" />
                                      <DiscordCallback />
                                    </>
                                  }
                                />

                                <Route
                                  path="/settings"
                                  element={
                                    <>
                                      <NoIndexSEO title="Налаштування" />
                                      <SettingsPage />
                                    </>
                                  }
                                />

                                <Route
                                  path="/register"
                                  element={
                                    <>
                                      <NoIndexSEO title="Реєстрація" />
                                      <RegistrationPage />
                                    </>
                                  }
                                />

                                {/* Catch-all, must stay last. Amplify answers 200 for unknown
                                    paths and that is deliberate (see Phase 1.3 in
                                    docs/seo-improvement-plan.md) — the noindex this page emits
                                    is what keeps those URLs out of the index. */}
                                <Route path="*" element={<NotFound />} />
                              </Routes>
                            </GlobalContainer>
                            <Footer />
                          </ThemeProvider>
                        </RacesProvider>
                      </HighlightsProvider>
                    </ScheduleProvider>
                  </StandingsProvider>
                </DriverProvider>
              </DriversProvider>
            </BannerProvider>
          </NewsProvider>
        </InventoryProvider>
      </UserProvider>
    </BrowserRouter>
  );
}

export default App;
